import styled from 'styled-components';
import { HelperText, ProductiveHeading05 } from 'components/styles';

const Title = styled.div`
  ${ProductiveHeading05};
`;
const SubTitle = styled.div`
  ${HelperText};
`;

const Description = styled.div`
  margin-top: var(--layout-01);
  width: 80%;
`;

const RadioDescription = styled.div`
  ${HelperText};
`;

export const MoveTaskAlertStyled = {
  Title,
  SubTitle,
  Description,
  RadioDescription,
};
